import React from 'react';
import { TipsAndUpdatesTwoTone } from '@mui/icons-material';
import { Box } from '@mui/material';
import { PAGE_TEXT as PRE_CHECK_TEXT } from '../../../../Nomination/components/lang';
import { PROGRAMME, QUALIFICATION_CHECK_ITEM } from './constants';
import type { QualificationCheckType } from './types';

const PROGRAMME_DISPLAY = {
  [PROGRAMME.MPHIL_2]: '2-year Full-time/ 4-year Part-time MPhil',
  [PROGRAMME.PHD_3]: ' 3-year Full-time/ 6-year Part-time PhD',
  [PROGRAMME.PHD_4]: ' 4-year Full-time/ 8-year Part-time PhD',
};

const QUALIFICATION_CHECK_DISPLAY = {
  [QUALIFICATION_CHECK_ITEM.GENERAL]: 'General Entrance',
  [QUALIFICATION_CHECK_ITEM.ENGLISH]: 'English Language',
};

export type QualificationCheckProps = {
  qualificationChecks: QualificationCheckType;
};

export const QualificationCheck: React.FunctionComponent<
  QualificationCheckProps
> = props => {
  const { qualificationChecks } = props;
  return (
    <Box>
      <div className="flex flex-row item-end">
        <TipsAndUpdatesTwoTone sx={{ color: '#951D1D' }} />
        <span className="font-bold text-[#951D1D] ml-2">
          {PRE_CHECK_TEXT.GSB1_FORM.SUGGEST_OFFER}
        </span>
      </div>
      {[PROGRAMME.MPHIL_2, PROGRAMME.PHD_3, PROGRAMME.PHD_4].map(
        (programme, index) => {
          return (
            <div key={programme} className="px-2 leading-loose">
              <h2>
                {`${index + 1}. ${PROGRAMME_DISPLAY[programme]} - `}
                <span className="italic font-semibold">
                  {qualificationChecks[programme]?.result}
                </span>
              </h2>
              {[
                QUALIFICATION_CHECK_ITEM.GENERAL,
                QUALIFICATION_CHECK_ITEM.ENGLISH,
              ].map(item => {
                return (
                  <div key={item} className="ml-4">
                    {`${QUALIFICATION_CHECK_DISPLAY[item]}: `}
                    <span className="italic">
                      {qualificationChecks[programme]?.items?.[item]}
                    </span>
                  </div>
                );
              })}
            </div>
          );
        },
      )}
    </Box>
  );
};
